/**
 * @author xyguo
 * @description 新开业培训要求管理
 * @Date 2021/3/11
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool,component_tool } from '@/tool';
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport,WizCard,WizTabs,WizSpin} = component_tool;
import {handleExport} from "./utils";
import moment from "moment";
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}

const formatterMinute = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const formatterType = (val) => {
  let newVal;
  switch (val){
    case  1 : newVal ='4S网点'
      break;
    case  2 : newVal ='直营店'
      break;
    case  3 : newVal ='单一售后'
      break;
    case  4 : newVal ='单一销售'
      break;
    case  5 : newVal ='卫星店/直营店'
      break;
    case  6 : newVal ='自修站'
      break;
    case  7 : newVal ='卫星店'
      break;
    case  8 : newVal ='精品店'
      break;
    case  9 : newVal ='dealer'
      break;
    case  10 : newVal ='4S店'
      break;
    case  11: newVal ='汽车零售'
      break;
    case  12 : newVal ='单一销售展厅'
      break;
    case  13 : newVal ='NEV单一售后'
      break;
    case  14 : newVal = '轻量化4S网点'
      break;
    case  15 : newVal = 'NEV专区'
      break;
    case  16 : newVal = '商超店'
      break;
    case 17 :  newVal = '自修店'
      break;
    case 18 :  newVal = '二级网点'
      break;
    case 19 :  newVal = '车工坊C1'
      break;
    case 20 :  newVal = '车工坊C2'
      break;
    case 21 :  newVal = '车工坊B'
      break;
    case 22 :  newVal = '德科品牌授权经销商'
      break;
    case 99 :  newVal = '暂定'
      break;
    default :  newVal = '无';
  }
  return newVal;
}

class RequirementPersonnelList extends WizContainer {

  componentName = 'RequirementPersonnelList';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '经销商名称',
        field: 'dealerName',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '经销商简称',
        field: 'shortName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '销售代码',
        field: 'preSalesNumber',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '售后代码',
        field: 'afterSalesNumber',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '预估开业时间',
        field: 'openTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '开店时间',
        field: 'dealerOpenTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '是否需要标杆店实践',
        field: 'benchmark',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '品牌',
        field: 'brandName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '站点类型',
        field: 'type',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: 'NEV类型',
        field: 'nevTypeCh',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '状态',
        field: 'state',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '完成时间',
        field: 'completeTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      }

    ]
    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        e['benchmark'] == 0 ? e['benchmark'] = "否" : e['benchmark'] = "是"
        switch( e['state'] ){
          case 0 : e['state'] = "培训中"
            break
          case 1 : e['state'] = "已完成"
            break
          case 2 : e['state'] = "达标确认"
            break
          case 3 : e['state'] = "人员有变更，请重新确认"
            break
          case 4 : e['state'] = "已开店达标确认"
            break
          case 5 : e['state'] = "已开店未达标"
            break
          default:
            e['state'] = ''
        }
        e['openTime'] = formatterDate(e['openTime']);
        e['dealerOpenTime'] = formatterDate(e['dealerOpenTime']);
        e['completeTime'] = formatterMinute(e['completeTime']);
        e['type'] =  formatterType(e['type']);
      })
      WizBrowserExport({
        title: '新开业人员培训',
        sheetName: '新开业人员培训',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '新开业人员培训.xlsx',
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        export: this._handleFile,
        exportTypeReport: handleExport.bind(this, {title: '新开业人员培训详情', column: []}),
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(RequirementPersonnelList);
